function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function (obj) {
      return typeof obj;
    };
  } else {
    _typeof = function (obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

var css = function css(strings) {
  for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }

  // merge all of the evaluated values from the template literal
  var evaluated = strings.reduce(function (acc, string, i) {
    acc.push(string);
    if (args[i]) acc.push(args[i]);
    return acc;
  }, []);
  return evaluated;
};

var cap = function cap(str) {
  return str.charAt(0).toUpperCase() + str.slice(1);
};

/* eslint-disable sort-keys */

/* eslint-disable no-inline-comments */
var breakpoints = {
  xs: 0,
  sm: 48,
  // 768
  md: 64,
  // 1024
  lg: 76,
  // 1216
  phone: 0,
  tablet: 48,
  tabletLandscape: 64,
  desktop: 76
};

var getBps = function getBps(props) {
  var _props$theme;

  return _objectSpread2(_objectSpread2({}, breakpoints), (props === null || props === void 0 ? void 0 : (_props$theme = props.theme) === null || _props$theme === void 0 ? void 0 : _props$theme.breakpoints) || {});
};

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8;

var getBp = function getBp(bp, props, options) {
  var bps = getBps(props);

  if (bps[bp]) {
    return "".concat(bps[bp] - (options && options.isMax ? 1 / 16 : 0), "em");
  }

  if (typeof bp === 'number') {
    return "".concat(bp - (options && options.isMax ? 1 / 16 : 0), "em");
  }

  return bp || '100%';
};

var mq = {
  upTo: function upTo(bp, style) {
    return function (props) {
      return css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    @media only screen and (max-width: ", ") {\n      ", ";\n    }\n  "])), getBp(bp, props, {
        isMax: true
      }), style);
    };
  },
  from: function from(bp, style) {
    return function (props) {
      return css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    @media only screen and (min-width: ", ") {\n      ", ";\n    }\n  "])), getBp(bp, props), style);
    };
  },
  between: function between(bp1, bp2, style) {
    return function (props) {
      return css(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n    @media only screen and (min-width: ", ") and (max-width: ", ") {\n      ", ";\n    }\n  "])), getBp(bp1, props), getBp(bp2, props, {
        isMax: true
      }), style);
    };
  },
  phone: function phone(style) {
    return function (props) {
      return css(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n    @media only screen and (max-width: ", ") {\n      ", ";\n    }\n  "])), getBp('tablet', props, {
        isMax: true
      }), style);
    };
  },
  tablet: function tablet(style) {
    return function (props) {
      return css(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n    @media only screen and (min-width: ", ") {\n      ", ";\n    }\n  "])), getBp('tablet', props), style);
    };
  },
  tabletLandscape: function tabletLandscape(style) {
    return function (props) {
      return css(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n    @media only screen and (min-width: ", ") {\n      ", ";\n    }\n  "])), getBp('tabletLandscape', props), style);
    };
  },
  tabletLandscapeMax: function tabletLandscapeMax(style) {
    return function (props) {
      return css(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n    @media only screen and (max-width: ", ") {\n      ", ";\n    }\n  "])), getBp('tabletLandscape', props, {
        isMax: true
      }), style);
    };
  },
  desktop: function desktop(style) {
    return function (props) {
      return css(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n    @media only screen and (min-width: ", ") {\n      ", ";\n    }\n  "])), getBp('desktop', props), style);
    };
  }
};

var getVariables = function getVariables(list, theme) {
  var keys = typeof list === 'string' && list.split('.');
  var shouldIterate = keys && keys.length > 1;

  if (!!keys && theme) {
    return shouldIterate ? getVariables(keys.slice(1).join('.'), theme[keys[0]]) : theme[list];
  }

  return list;
};

var toCamelCase = function toCamelCase(str) {
  return !str ? '' : String(str).replace(/^[^A-Za-z0-9]*|[^A-Za-z0-9]*$/g, '').replace(/[^A-Za-z0-9]+/g, '$').replace(/([a-z])([A-Z])/g, function (_, a, b) {
    return "".concat(a, "$").concat(b);
  }).toLowerCase().replace(/(\$)(\w)/g, function (_, a, b) {
    return b.toUpperCase();
  });
};

var camelcase = function camelcase(obj) {
  return !obj ? null : Object.keys(obj).reduce(function (acc, key) {
    return _objectSpread2(_objectSpread2({}, acc), {}, _defineProperty({}, toCamelCase(key), obj[key]));
  }, {});
};

var flatten = function flatten(objectOrArray) {
  var prefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

  var nestElement = function nestElement(prev, value, key) {
    return value && _typeof(value) === 'object' ? _objectSpread2(_objectSpread2({}, prev), flatten(value, "".concat(prefix).concat(key, "."))) : _objectSpread2(_objectSpread2({}, prev), _defineProperty({}, "".concat(prefix).concat(key), value));
  };

  return Array.isArray(objectOrArray) ? objectOrArray.reduce(nestElement, {}) : Object.keys(objectOrArray).reduce(function (prev, element) {
    return nestElement(prev, objectOrArray[element], element);
  }, {});
};

var parseNestedProps = function parseNestedProps(props) {
  var flattenObj = flatten(props, '-');
  var camelCased = camelcase(flattenObj);
  return camelCased;
};

// helper function to
// returns css
var setCssProp = function setCssProp(cssProp, value, units) {
  return "\n  ".concat(cssProp, ": ").concat(value).concat(typeof value === 'number' && !!units ? units : '', ";\n");
};

var applyNamedProp = function applyNamedProp(allProps, _ref) {
  var list = _ref.list,
      cssProp = _ref.cssProp,
      _ref$prefix = _ref.prefix,
      prefix = _ref$prefix === void 0 ? '' : _ref$prefix,
      units = _ref.units;

  var theme = allProps.theme,
      props = _objectWithoutProperties(allProps, ["theme"]);

  var variables = getVariables(list, theme);

  if (!variables) {
    return null;
  }

  var propKeys = Object.keys(props);
  var variableKeys = Object.keys(variables);
  var withNestedProps = variableKeys.reduce(function (result, key) {
    return result || _typeof(variables[key]) === 'object';
  }, false); // sets an array
  // with matched props
  // from the variables list

  var match = variableKeys.filter(function (variable) {
    return propKeys.find(function (prop) {
      return "".concat(prop) === "".concat(prefix).concat(prefix ? cap(variable) : variable);
    });
  });

  if (!match.length && !withNestedProps) {
    return;
  }

  var parsedProps = null; // if there's no match
  // will try to find for
  // camelCased separations
  // grey.light will be greyLight

  if (!match.length) {
    // try to find deep val
    parsedProps = parseNestedProps(variables);
    match = Object.keys(parsedProps).filter(function (variable) {
      return propKeys.find(function (prop) {
        return "".concat(prop) === "".concat(prefix).concat(prefix ? cap(variable) : variable);
      });
    });

    if (!match.length) {
      return;
    }
  }

  var matchIndex = match.length - 1;
  var propName = "".concat(prefix).concat(prefix ? cap(match[matchIndex]) : match[matchIndex]);
  var propVal = props[propName];
  var value = !parsedProps ? variables[match[matchIndex]] : parsedProps[match];
  var breakpoints = getBps({
    theme: theme
  }); // return the styled-component
  // css fn with the matched val
  // or if prop has a string value
  // that matches with a breakpoint
  // returns the helper that sets
  // the css only for that breakpoint
  // ex: fontWeightBold="md" -> will only
  // be applyed in screens wider than
  // breakpoints.md

  return typeof propVal === 'string' && Object.keys(breakpoints).find(function (bp) {
    return bp === propVal;
  }) ? mq.from(propVal, setCssProp(cssProp, value, units)) : setCssProp(cssProp, value, units);
};

var applyNamedProps = function applyNamedProps(props) {
  var _props$theme, _props$theme$generato;

  var namedProps = props === null || props === void 0 ? void 0 : (_props$theme = props.theme) === null || _props$theme === void 0 ? void 0 : (_props$theme$generato = _props$theme.generator) === null || _props$theme$generato === void 0 ? void 0 : _props$theme$generato.namedProps;

  if (!(namedProps !== null && namedProps !== void 0 && namedProps.length)) {
    return;
  }

  return namedProps.map(function (namedProp) {
    return applyNamedProp(props, namedProp);
  });
};

var nulify = function nulify(val) {
  return val === 'null' || val === 'undefined' || val === 'false' ? null : val;
};

var isInvalid = function isInvalid(val) {
  return val === undefined || val === null || val === false || nulify(val) === null;
};

/* eslint-disable sort-keys */
// function to find
// match props recursively
var getProp = function getProp(_ref) {
  var list = _ref.list,
      key = _ref.key,
      units = _ref.units;

  // breaks if there's
  // no key provided
  // it's the only
  // required arg
  if (!key) {
    return null;
  } // if the key is a number,
  // just returns it back,
  // with the units, if
  // there's one


  if (typeof key === 'number') {
    return "".concat(key).concat(units && typeof +key === 'number' ? units : '');
  } // splits key into
  // arr of keys if any
  // dot separator.


  var keys = key.split('.'); // check if it's an iterateble
  // prop testing if the array
  // have more than 1 value

  var shouldIterate = keys.length > 1; // first, try to fetch value
  // using the keys[0]
  // from the list (if exists)

  var val = !!list && list[keys] ? list[keys[0]] : undefined; // if there's a value and should not
  // iterate, returns it.
  //
  // checking only if val is not undefined
  // because we want 0 to pass it too

  if (val !== undefined && !shouldIterate) {
    // check if there's any passed units
    // and if the value is a number. If
    // it is, apply the units
    return "".concat(val).concat(units && typeof +val === 'number' ? units : '');
  } // if val is undefined and if should
  // not iterate, just returns the
  // key as it was received


  if (!shouldIterate) {
    return key; // else
    // just iterates all over again
  }

  return getProp({
    // passes the same list
    list: list[keys[0]],
    // removes the first key and
    // passes the rest to the next
    // iteration as a dot string again
    key: keys.slice(1).join('.'),
    // passes the same units
    units: units
  });
};

var applyVariableProp = function applyVariableProp(props, _ref) {
  var name = _ref.name,
      list = _ref.list,
      helperFn = _ref.helperFn,
      cssProp = _ref.cssProp,
      units = _ref.units;

  // check if props and name is being
  // passed and if prop exists
  if (!name || !props || props[name] === undefined) {
    return;
  } // sets the variables list


  var variables = getVariables(list, props.theme); // internal helper fn that
  // will be returned

  var setCss = function setCss(propVal) {
    // check if there's an helper
    // function with the prop name
    var useFunction = !!helperFn && typeof helperFn === 'function'; // if no val, just
    // returns null

    if (isInvalid(propVal) && !useFunction) {
      return null;
    } // check if the val is a string
    // or if splitted, have more than
    // one arg. If yes, just returns an
    // array nulified to use with the
    // helper fns from polished
    // ex: "10 0 null auto" will be
    // [10, 0, null, 'auto']
    // if it's not multi arg, just return
    // the unchanged value


    var prop = typeof propVal === 'string' && propVal.split(' ').length > 1 ? propVal.split(' ').map(function (p) {
      return nulify(p);
    }) : propVal;

    if (!useFunction) {
      return typeof prop === 'number' || !variables ? setCssProp(cssProp, prop, units) : setCssProp(cssProp, getProp({
        key: prop,
        list: variables,
        units: units
      }));
    }

    return Array.isArray(prop) ? helperFn.apply(void 0, _toConsumableArray(prop.map(function (propArg) {
      return (// eslint-disable-next-line no-nested-ternary
        !Number.isNaN(+propArg) && propArg > 0 && typeof propArg !== 'boolean' ? "".concat(propArg).concat(units) : typeof propArg === 'boolean' ? undefined : propArg
      );
    }))) : helperFn( // eslint-disable-next-line no-nested-ternary
    !Number.isNaN(+prop) && typeof prop !== 'boolean' ? "".concat(+prop).concat(units) : typeof prop === 'boolean' ? undefined : prop);
  }; // check if the value of the prop
  // is string or number and if yes,
  // returns the internal setCss fn


  if (typeof props[name] === 'string' || typeof props[name] === 'number' || typeof props[name] === 'boolean') {
    return setCss(props[name]);
  } // if the value is not a string, number
  // or an object, we don't want it, so
  // we return a console log saying that


  if (_typeof(props[name]) !== 'object') {
    /* eslint-disable-next-line */
    return console.log("wrong format in prop ".concat(name, ": "), props[name]);
  } // sets the prop breakpoints keys


  var propKeys = Object.keys(props[name]); // get breakpoints using
  // styled-helper-mq breakpoint fn

  var breakpoints = getBps(props); // sets the theme breakpoints keys

  var bpKeys = Object.keys(breakpoints); // reduce the prop breakpoints returning a
  // parsed arr to be iterated

  var bps = propKeys.reduce(function (acc, bp) {
    var breakpoint = bpKeys.find(function (b) {
      return bp === b;
    });
    return breakpoint ? [].concat(_toConsumableArray(acc), [{
      breakpoint: breakpoints[breakpoint],
      prop: props[name][bp]
    }]) : acc;
  }, []); // returns the setCss with breakpoints

  return bps.length ? bps.sort(function (a, b) {
    return a.breakpoint - b.breakpoint;
  }).reduce(function (acc, bp) {
    return [].concat(_toConsumableArray(acc), [mq.from(bp.breakpoint, setCss(bp.prop))]);
  }, []) : null;
}; // iterates over the
// variable props config


var applyVariableProps = function applyVariableProps(props) {
  var _props$theme, _props$theme$generato;

  var variableProps = props === null || props === void 0 ? void 0 : (_props$theme = props.theme) === null || _props$theme === void 0 ? void 0 : (_props$theme$generato = _props$theme.generator) === null || _props$theme$generato === void 0 ? void 0 : _props$theme$generato.variableProps;

  if (!(variableProps !== null && variableProps !== void 0 && variableProps.length)) {
    return;
  }

  return variableProps.map(function (variableProp) {
    return applyVariableProp(props, variableProp);
  });
};

var sidesArr = ['top', 'right', 'bottom', 'left'];

var applySpaceProp = function applySpaceProp(allProps, _ref) {
  var prop = _ref.prop,
      list = _ref.list,
      units = _ref.units;

  var theme = allProps.theme,
      props = _objectWithoutProperties(allProps, ["theme"]);

  if (!prop) {
    return;
  }

  var firstLetter = prop.charAt(0);
  var variables = getVariables(list, theme);
  return sidesArr.map(function (side) {
    var applyObj = {
      cssProp: "".concat(prop, "-").concat(side),
      list: variables,
      name: "".concat(firstLetter).concat(side.charAt(0)),
      units: units || 'rem'
    };
    return applyVariableProp(_objectSpread2({
      theme: theme
    }, props), applyObj);
  });
};

var applySpaceProps = function applySpaceProps(props) {
  var _props$theme, _props$theme$generato;

  var spaceProps = props === null || props === void 0 ? void 0 : (_props$theme = props.theme) === null || _props$theme === void 0 ? void 0 : (_props$theme$generato = _props$theme.generator) === null || _props$theme$generato === void 0 ? void 0 : _props$theme$generato.spaceProps;

  if (!(spaceProps !== null && spaceProps !== void 0 && spaceProps.length)) {
    return;
  }

  return spaceProps.map(function (config) {
    return applySpaceProp(props, config);
  });
};

var _templateObject$1;
var generateProps = function generateProps(args) {
  delete args.children;

  var theme = args.theme,
      props = _objectWithoutProperties(args, ["theme"]);

  if (!Object.keys(props).length || _typeof(props) !== 'object') {
    return;
  }

  var namedProps = Object.keys(props).reduce(function (acc, prop) {
    return typeof props[prop] === 'boolean' || typeof props[prop] === 'undefined' ? _objectSpread2(_objectSpread2({}, acc), {}, _defineProperty({}, prop, props[prop])) : acc;
  }, {});
  var isNamedPropsEmpty = !Object.keys(namedProps).length;
  var valueProps = Object.keys(props).reduce(function (acc, prop) {
    return _typeof(props[prop]) === 'object' || typeof props[prop] === 'string' || typeof props[prop] === 'number' || typeof props[prop] === 'boolean' || Array.isArray(props[prop]) ? _objectSpread2(_objectSpread2({}, acc), {}, _defineProperty({}, prop, props[prop])) : acc;
  }, {});
  var isValuePropsEmpty = !Object.keys(valueProps).length;

  if (isValuePropsEmpty && isNamedPropsEmpty) {
    return;
  }

  return css(_templateObject$1 || (_templateObject$1 = _taggedTemplateLiteral(["\n    ", ";\n    ", ";\n    ", ";\n  "])), !isNamedPropsEmpty ? applyNamedProps(_objectSpread2({
    theme: theme
  }, namedProps)) : '', !isValuePropsEmpty ? applyVariableProps(_objectSpread2({
    theme: theme
  }, valueProps)) : '', !isValuePropsEmpty ? applySpaceProps(_objectSpread2({
    theme: theme
  }, valueProps)) : '');
};

var _templateObject$2;
// a css font-face string

var fontFace = function fontFace(_ref) {
  var family = _ref.family,
      weight = _ref.weight,
      style = _ref.style,
      src = _ref.src;
  return css(_templateObject$2 || (_templateObject$2 = _taggedTemplateLiteral(["\n  @font-face {\n    font-family: ", ";\n    font-weight: ", ";\n    font-style: ", ";\n    src: ", ";\n  }\n"])), family, weight, style, src);
}; // default font formats


var defaultFormats = ['woff', 'woff2'];

var importFont = function importFont(font, fontFormats) {
  var family = font.family,
      path = font.path,
      prefix = font.prefix,
      weights = font.weights,
      localLoading = font.localLoading; // if fontFormats is undefined
  // uses defaultFormats

  var formats = fontFormats || defaultFormats; // iterates over weights array
  // and return fontFace fn
  // parsing and joining all
  // the formats in src

  return Object.keys(weights).map(function (weight) {
    return fontFace({
      family: family,
      src: formats.reduce(function (acc, format) {
        return [].concat(_toConsumableArray(acc), ["".concat(localLoading ? "local(\"".concat(family, " ").concat(cap(weight), "\"), local(\"").concat(prefix).concat(weight, "\"), ") : ' ', "url(\"").concat(path, "/").concat(prefix).concat(weight, ".").concat(format, "\") format(\"").concat(format, "\")")]);
      }, []).join(',\n'),
      style: 'normal',
      weight: weights[weight]
    });
  });
}; // iterares over the theme fonts config
// property and returns importFont


var importFonts = function importFonts(props) {
  return props && props.theme && props.theme.fonts && props.theme.fonts.config && props.theme.fonts.config.length && props.theme.fonts.config.map(function (font) {
    return importFont(font, props.theme.fonts.formats);
  });
};

var durations = {
  animation: 500,
  hover: 250,
  long: 750,
  short: 350
};

/* eslint-disable sort-keys */
var ease = {
  inSine: 'cubic-bezier(0.47, 0, 0.745, 0.715)',
  outSine: 'cubic-bezier(0.39, 0.575, 0.565, 1)',
  inOutSine: 'cubic-bezier(0.445, 0.05, 0.55, 0.95)',
  inQuad: 'cubic-bezier(0.55, 0.085, 0.68, 0.53)',
  outQuad: 'cubic-bezier(0.25, 0.46, 0.45, 0.94)',
  inOutQuad: 'cubic-bezier(0.455, 0.03, 0.515, 0.955)',
  inCubic: 'cubic-bezier(0.55, 0.055, 0.675, 0.19)',
  outCubic: 'cubic-bezier(0.215, 0.61, 0.355, 1)',
  inOutCubic: 'cubic-bezier(0.645, 0.045, 0.355, 1)',
  inQuart: 'cubic-bezier(0.895, 0.03, 0.685, 0.22)',
  outQuart: 'cubic-bezier(0.165, 0.84, 0.44, 1)',
  inOutQuart: ' cubic-bezier(0.77, 0, 0.175, 1)',
  inQuint: 'cubic-bezier(0.755, 0.05, 0.855, 0.06)',
  outQuint: 'cubic-bezier(0.23, 1, 0.32, 1)',
  inOutQuint: 'cubic-bezier(0.86, 0, 0.07, 1)',
  inExpo: 'cubic-bezier(0.95, 0.05, 0.795, 0.035)',
  outExpo: 'cubic-bezier(0.19, 1, 0.22, 1)',
  inOutExpo: 'cubic-bezier(1, 0, 0, 1)',
  inCirc: 'cubic-bezier(0.6, 0.04, 0.98, 0.335)',
  outCirc: 'cubic-bezier(0.075, 0.82, 0.165, 1)',
  inOutCirc: 'cubic-bezier(0.785, 0.135, 0.15, 0.86)',
  inBack: 'cubic-bezier(0.6, -0.28, 0.735, 0.045)',
  outBack: 'cubic-bezier(0.175, 0.885, 0.32, 1.275)',
  inOutBack: 'cubic-bezier(0.68, -0.55, 0.265, 1.55)'
};

var _templateObject$3;
var defaultDuration = 500;

var transition = function transition(props, _ref) {
  var _props$theme, _props$theme2;

  var cssProps = _ref.cssProps,
      duration = _ref.duration,
      ease$1 = _ref.ease;
  var themeDurations = (props === null || props === void 0 ? void 0 : (_props$theme = props.theme) === null || _props$theme === void 0 ? void 0 : _props$theme.duration) || {};

  var durationLib = _objectSpread2(_objectSpread2({}, durations), {}, {
    themeDurations: themeDurations
  });

  var themeEases = (props === null || props === void 0 ? void 0 : (_props$theme2 = props.theme) === null || _props$theme2 === void 0 ? void 0 : _props$theme2.ease) || {};

  var easeLib = _objectSpread2(_objectSpread2({}, ease), {}, {
    themeEases: themeEases
  });

  var durationVal = durationLib[duration] || duration || defaultDuration;
  return "".concat(cssProps || 'all', " ").concat(typeof durationVal === 'number' ? "".concat(durationVal, "ms") : durationVal, " ").concat(easeLib[ease$1] || ease$1);
};

var setTransitions = function setTransitions(props, _ref2) {
  var cssProps = _ref2.cssProps,
      duration = _ref2.duration,
      ease = _ref2.ease;
  return Array.isArray(cssProps) ? cssProps.map(function (cssProp) {
    return transition(props, {
      cssProps: cssProp,
      duration: duration,
      ease: ease
    });
  }).join(', ') : transition(props, {
    cssProps: cssProps,
    duration: duration,
    ease: ease
  });
};

var transitions = function transitions(cssProps, duration, ease) {
  return function (props) {
    return css(_templateObject$3 || (_templateObject$3 = _taggedTemplateLiteral(["\n  transition: ", ";\n"])), setTransitions(props, {
      cssProps: cssProps,
      duration: duration,
      ease: ease
    }));
  };
};

var _templateObject$4;

var getVariations = function getVariations(props, variations) {
  var variationName = Object.keys(variations).reduce(function (results, variation) {
    return Object.keys(props).find(function (prop) {
      return props[variation] && prop === variation;
    }) || results;
  }, []);
  return variations[variationName] || (variations === null || variations === void 0 ? void 0 : variations.default) || null;
};

var variations = function variations(_variations) {
  return function (props) {
    return css(_templateObject$4 || (_templateObject$4 = _taggedTemplateLiteral(["\n  ", ";\n"])), getVariations(props, _variations));
  };
};

export { breakpoints, durations, ease, generateProps, getBps, importFonts, mq, transitions, variations };
//# sourceMappingURL=index.es.js.map
